import z from 'zod';

const arraySchema = z
  .preprocess((v: string[]) => {
    if (typeof v !== 'string') return v;
    try {
      return JSON.parse(v);
    } catch {
      return v;
    }
  }, z.array(z.string()))
  .default([]);

export const accountActivityQuerySchema = z
  .object({
    activities: arraySchema,
    orders: arraySchema,
    devices: arraySchema,
    applications: arraySchema,
    locations: arraySchema,
  })
  .default({
    activities: [],
    orders: [],
    devices: [],
    applications: [],
    locations: [],
  });

export type AccountActivityQuery = z.infer<typeof accountActivityQuerySchema>;
